$ = require 'jquery'
Elements = require './elements'
Backbone = require 'backbone'
Data = require '../data'
Deblurring = require './deblurring'
{ defaults, merge } = require 'lodash'
{ parse } = require '../../components/query-string'
{ getParams, addParam, deleteParam } = require './params'
require('malihu-custom-scrollbar-plugin')($)

module.exports =
class ToggleDetail

  mainSelector  : '.main-container'
  detailSelector: '.lower-container'
  closeSelector : '.close'
  coverClass    : 'cover'
  detailParams  : 'detail'

  constructor: (@el, @openEl, @name) ->
    @$window = Elements.$window
      .one
        'pagesLoaded': @onPagesLoaded
      .on
        'resize': @onWindowResized
    @$wrap = Elements.$wrap
    @$cmn  = Elements.$logo.add(Elements.$nav).add(Elements.$menuBtn).add(Elements.$copyright)

    @hasPushState = window.history and history.pushState

  onPagesLoaded: =>
    @$section = $ @el
    @$main    = @$section.find @mainSelector
    @$detail  = @$section.find @detailSelector
    @$close   = @$section.find @closeSelector
    @$cover   = $()

    @detailW = @$detail.width()

    @$detail.mCustomScrollbar
      axis               : 'y'
      theme              : 'dark-thin'
      scrollbarPosition  : 'outside'
      autoExpandScrollbar: true
      scrollButtons      :
        enable: true

    @deblurring = new Deblurring @$detail

  on: ->
    @$close.on 'click', @onCloseClicked
    @$section.on 'click', @openEl, @onOpenClicked

  off: ->
    @$close.off 'click'
    @$section.off 'click'

  onWindowResized: =>
    @detailW = @$detail.width()
    if @$cover.length
      @$cmn.add(@$main).add(@$cover)
        .velocity
          translateX: -@detailW
        , duration: 0

  onOpenClicked: (e) =>
    $el    = $ e.currentTarget
    target = $el.data 'target'
    query  = $.param merge(getParams(), { "#{@detailParams}": target })
    pathname =
      if @hasPushState
        location.pathname
      else
        Data.directory[Data.location]
    Backbone.history.navigate "#{pathname}?#{query}", true

  onCloseClicked: =>
    params   = getParams()
    delete params[@detailParams]
    query    = $.param params
    pathname =
      if @hasPushState
        location.pathname
      else
        Data.directory[Data.location]
    fragment =
      if query then "#{pathname}?#{query}" else pathname
    Backbone.history.navigate fragment, true

  open: (target) =>
    addParam Data.location, @detailParams, target
    @$window
      .trigger "detailOpenBefore.all"
      .trigger "detailOpenBefore.#{@name}", [target]
    @$detail.css 'display', 'block'
    @toggle -@detailW,
      easing: 'easeOutBack'
      begin: @createCover
      complete: =>
        @deblurring.redraw()
        @$window
          .trigger "detailOpenAfter.all"
          .trigger "detailOpenAfter.#{@name}", [target]
        ga 'send', 'pageview', "#{location.pathname}#{location.search}#{location.hash}"

  close: =>
    deleteParam Data.location, @detailParams
    @$window
      .trigger "detailCloseBefore.all"
      .trigger "detailCloseBefore.#{@name}"
    @toggle 0,
      easing: 'easeInBack'
      begin: @removeCover
      complete: =>
        @$detail.css 'display', 'none'
        @$window
          .trigger "detailCloseAfter.all"
          .trigger "detailCloseAfter.#{@name}"

  toggle: (x, opts) ->
    opts = defaults opts,
      duration: 750

    @$cmn.add @$main
      .velocity 'stop'
      .velocity
        translateX: x
      , opts

  createCover: =>
    unless @$cover.length
      @$wrap.append "<div class='#{@coverClass}'></div>"
    @$cover = @$wrap.find ".#{@coverClass}"
      .velocity 'stop'
      .velocity
        opacity   : 1
        translateX: -@detailW
      ,
        duration: 750
        easing  : 'easeOutBack'
        complete: =>
          @$cover.on 'click', @onCloseClicked

  removeCover: =>
    remove = =>
      @$cover.remove()
      @$cover = $()

    if Number @$cover.css('opacity')
      @$cover
        .velocity 'stop'
        .velocity
          opacity   : 0
          translateX: 0
        ,
          duration: 750
          easing  : 'easeInBack'
          complete: remove
    else
      remove()



// WEBPACK FOOTER //
// ./webpack/requires/pc/views/toggle-detail.coffee